(function () {
  // data class that does all maths and mechanics for a slotmachine reel. Does not have dependencies on any libs including Pixi or Reflex libs
  // the one exception being the state machine in Reflex libs. But thats ok because I like that class!
  class ReelSpinnerData {
    constructor(
      reelId,
      maxAppertureHeight,
      symbolSpacing,
      reservedSpace,
      numPreapp,
      numPostapp
    ) {
      this._reelId = reelId;
      this._preInjector = false;
      this._postInjector = false;
      this._maxAppertureHeight = maxAppertureHeight; // how many symbols will maximum will be in the window. In a 5x3 game this is 3
      this._currentAppertureHeight = this._maxAppertureHeight; // default to max. This is used for MegaWays
      this._preAppertureSymbols = numPreapp; // how many extra symbols need to be created to for mid spins
      this._postAppertureSymbols = numPostapp;
      this._totalAppertureSize =
        this._maxAppertureHeight +
        this._preAppertureSymbols +
        this._postAppertureSymbols;
      this._spinModes = {}; // map of all available spin modes
      this._symbolData = [];
      this._savedSymbolData = [];
      this._minSymbolSpacing = symbolSpacing;
      this._deltaTime = 0; // all spin movement is based on time to travel 1 symbol
      this._slamStopReels = false;
      this._currentInjector = undefined;
      this._spinTime = 0;
      this._onLandCallback = undefined;
      this._onHitCallback = undefined;
      this._onNewSymbolCallback = undefined;
      this._onOldSymbolRemovedCallback = undefined;
      this._reservedSpace = reservedSpace;
      this._abortSymbols = [];
      this._travelledSinceStart = 0;
      this._runningUniqueId = 0;
      this._reelSpinning = false;
      this._runningDelta = 0;
      this._aborted = false;
      this._isSpinning = false;
      this._frameCount = 0;
      this._bouncing = false;
      this._bounceDownTime = 0;
      this._bounceUpTime = 0;
      this._defaultReelParameters = {
        reverse: false,
        symbolsPerSecond: 20,
        decelerationDistance: 0,
        bounceDistance: 0,
        bounceTime: 0,
      };
      for (let i = 0; i < this._totalAppertureSize; ++i) {
        this._symbolData.push({
          symId: 0,
          yPos: 0,
          appertureHeight: this._currentAppertureHeight,
          uniqueId: this._runningUniqueId++,
        }); // pre/post-apperature symbols are the last symbols here. Index 0 is top of visible window
      }

      this._preAppertureSymbolIdx = this._maxAppertureHeight; // the start of the preapperture symbols are just below the window symbols in the list
      this._postAppertureSymbolIdx = this._preAppertureSymbolIdx + numPreapp; // the start of the postpperture symbols are just below the preappature symbols in the list
      this._bottomPreAppertureSymbolIdx = this._postAppertureSymbolIdx - 1; // when working with preapperture symbol it is really useful to work with the one directly above the window symbols

      // if the game is 5x3 and it has 2 preapperture and 2 post apperture symbols then the symbol data indexes would looks like

      // 3 -- first pre apperture (aboveSymbols[0]) symbol
      // 4 -- last pre apperture symbol (the one just above the window) aka this._bottomPreAppertureSymbolIdx
      // 0 -- start of the window (top visible symbol when reels are not spinning)
      // 1 -- middle of the window
      // 2 -- end of the window (bottom visible symbol when reels are not spinning)
      // 5 -- first post apperture symbol (directly below the window)
      // 6 -- last post apperture symbol

      // so the contents of symbolData is
      // [ top window, mid window, bot window, highest pre app symbol, lowest preapp symbol, first post app symbol, last post app symbol  ]

      this.setReelParameters({});
      this.resetSymbolPositions();
      this.createStates();
    }

    createStates() {
      StateMachine.Create(this);
      let self = this;
      this.stateMachine.addState('IDLE', function () {
        self.state_idle();
      });
      this.stateMachine.addState('PULLBACK', function () {
        self.state_pullback();
      });
      this.stateMachine.addState('ACCELERATE', function () {
        self.state_accelerate();
      });
      this.stateMachine.addState('INFINITE_SPIN', function () {
        self.state_infinite_spin();
      });
      this.stateMachine.addState('SPIN_TO_TARGET', function () {
        self.state_spin_to_target();
      });
      this.stateMachine.addState('DECELERATE', function () {
        self.state_decelerate();
      });
      this.stateMachine.addState('NUDGE', function () {
        self.state_nudge();
      });
    }

    setLogger(logger) {
      this.logger = logger;
    }

    // when the the reels have travelled a single symbol height we reset all the symbols Y Positions so it is fully off screen and
    // symbolData[0] is now back to very top of the window

    resetSymbolPositions() {
      if (!this._reelParameters.reverse) {
        this._symbolData[0].yPos = 0; // first symbol is always reset to 0

        // each symbol should be set to the symbol aboves its Y position plus its height. This slightly overcomplicated way allows for
        // dynamic symbol size (megaways) position be aligning the symbol up to the bottom of the previous symbol
        // window symbols
        for (let i = 1; i < this._maxAppertureHeight; ++i) {
          let previousSymbolHeight = this.getSymbolHeight(i - 1);
          this._symbolData[i].yPos =
            this._symbolData[i - 1].yPos + previousSymbolHeight; // previous symbols yPos plus its height
        }

        // pre apperture symbols
        for (
          let i = 0, iInverse = this._preAppertureSymbols;
          i < this._preAppertureSymbols;
          ++i, --iInverse
        ) {
          this._symbolData[this._preAppertureSymbolIdx + i].yPos = -(
            iInverse * this.getSymbolHeight(this._preAppertureSymbolIdx + i)
          ); //preappurture symbols goes above window, but the lower the index in the symbolData array the higher above the window the preapperture symbol is (hence inverse)
        }

        // post apperture symbol, first one
        for (let i = 0; i < 1; ++i) {
          let previousSymbolIdx = this._maxAppertureHeight - 1 + i; // last symbol in window when i is 0
          let previousSymbolHeight = this.getSymbolHeight(previousSymbolIdx);
          this._symbolData[this._postAppertureSymbolIdx + i].yPos =
            this._symbolData[previousSymbolIdx].yPos + previousSymbolHeight;
        }

        // final post apperture symbols
        for (let i = 1; i < this._postAppertureSymbols; ++i) {
          let previousSymbolIdx = this._postAppertureSymbolIdx - 1 + i; // last symbol in window when i is 0
          let previousSymbolHeight = this.getSymbolHeight(previousSymbolIdx);
          this._symbolData[this._postAppertureSymbolIdx + i].yPos =
            this._symbolData[previousSymbolIdx].yPos + previousSymbolHeight;
        }
      } else {
        let bottomOfWindowPos =
          this._maxAppertureHeight * this._minSymbolSpacing;
        let bottomSymbolIndex = this._preAppertureSymbolIdx - 1;
        this._symbolData[bottomSymbolIndex].yPos =
          bottomOfWindowPos - this.getSymbolHeight(bottomSymbolIndex);

        // each symbol should be set to the symbol aboves its Y position plus its height. This slightly overcomplicated way allows for
        // dynamic symbol size (megaways) position be aligning the symbol up to the bottom of the previous symbol
        for (let i = bottomSymbolIndex - 1; i >= 0; --i) {
          let previousSymbolHeight = this.getSymbolHeight(i);
          this._symbolData[i].yPos =
            this._symbolData[i + 1].yPos - previousSymbolHeight; // previous symbols yPos plus its height
        }

        // first preapperture symbols (the one next to the window symbol)
        this._symbolData[
          this._preAppertureSymbolIdx + this._preAppertureSymbols - 1
        ].yPos =
          this._symbolData[this._preAppertureSymbolIdx - 1].yPos +
          this.getSymbolHeight(
            this._preAppertureSymbolIdx + this._preAppertureSymbols - 1
          );

        // remaining preapps
        for (
          let i = this._preAppertureSymbols - 2, iInverse = 0;
          i >= 0;
          --i, ++iInverse
        ) {
          this._symbolData[this._preAppertureSymbolIdx + i].yPos =
            this._symbolData[this._preAppertureSymbolIdx + i + 1].yPos +
            this.getSymbolHeight(this._preAppertureSymbolIdx + i);
        }

        // first post apperture symbol
        this._symbolData[this._postAppertureSymbolIdx].yPos =
          this._symbolData[0].yPos -
          this.getSymbolHeight(this._postAppertureSymbolIdx);

        // final pre app symbols
        for (let i = 1; i < this._postAppertureSymbols; ++i) {
          this._symbolData[this._postAppertureSymbolIdx + i].yPos =
            this._symbolData[this._postAppertureSymbolIdx - 1 + i].yPos -
            this.getSymbolHeight(this._postAppertureSymbolIdx + 1);
        }
      }
    }

    getCurrentSymbolsPerSecond() {
      return this._reelParameters.symbolsPerSecond;
    }

    //returns the height of a symbol taken into account its dynamic appertureHeight (megaways)
    getSymbolHeight(symbolIndex) {
      return (
        (this._maxAppertureHeight /
          this._symbolData[symbolIndex].appertureHeight) *
        this._minSymbolSpacing
      );
    }

    getTotalAppertureSize() {
      return this._totalAppertureSize;
    }

    getMaxSymbolsInWindow() {
      return this._maxAppertureHeight;
    }

    getPreappertureSymbols() {
      // badly named function, returns the number of them, and not the actual symbols
      return this._preAppertureSymbols;
    }

    getPostappertureSymbols() {
      // badly named function, returns the number of them, and not the actual symbols
      return this._postAppertureSymbols;
    }

    getInjectors() {
      return {
        pre: this._preInjector,
        post: this._postInjector,
      };
    }

    getSymbolData() {
      return this._symbolData;
    }

    getCurrentAppertureHeight() {
      return this._currentAppertureHeight;
    }

    getSymbolAppertureHeight(symbolId) {
      return this._symbolData[symbolId].appertureHeight;
    }

    // this is to make sure that the dynamic symbols have enough space between source and target bands
    // to fit a symbol. I.E. a gigablox symbol might be 3x3, meaning that one symbol requires 3 vertical space
    // if the space provided for dynamic symbols do not fit full blocks then we will get slicing of symbols
    getReservedSpace() {
      return this._reservedSpace;
    }

    getRatioOfPreappertureSymbolInView(reverseSpin) {
      function clamp(num, min, max) {
        return num <= min ? min : num >= max ? max : num;
      }

      let symbolHeight = this.getSymbolHeight(
        this._bottomPreAppertureSymbolIdx
      );
      let symbolYPos = this._symbolData[this._bottomPreAppertureSymbolIdx].yPos;

      if (!reverseSpin) {
        let res = (symbolYPos + symbolHeight) / symbolHeight; // as the end position is 0, i.e. fully in view, this works. Wont work for reverse
        return clamp(res, 0, 1);
      } else {
        let windowHeight = this._maxAppertureHeight * this._minSymbolSpacing;
        symbolYPos -= windowHeight;
        let res = symbolYPos / symbolHeight;
        return clamp(res, 0, 1);
      }
    }

    setReelSymbol(index, symbolId) {
      if (index < this._totalAppertureSize) {
        this._symbolData[index].symId = symbolId;
        this._symbolData[index].uniqueId = this._runningUniqueId++;
      } else {
        console.error(
          'Trying to set a reel symbol greater than window size of '
        );
      }
    }

    setInjectors(preInjector, postInjector) {
      this._preInjector = preInjector;
      this._postInjector = postInjector;
      this._currentInjector = this._preInjector;
    }

    // chane the number of symbols that fit fully in the window
    setAppertureHeight(numInWindow) {
      this._currentAppertureHeight = numInWindow;
    }

    setReelParameters(params) {
      this._reelParameters = Object.assign(this._defaultReelParameters, params);
      this.resetSymbolPositions(); // this will move the preapperture symbol to bottom if reverse is set, otherwise code will think the preapperture symbol has moved a position
    }

    getDistanceTravelled() {
      return this._travelledSinceStart;
    }

    update(delta) {
      this._frameCount++;
      this._deltaTime = delta;
      this._runningDelta += delta;
      this.stateMachine.update();
    }

    // move symbols by travelDistance (in pixels)
    updatePos(travelDistance) {
      for (let i = 0; i < this._totalAppertureSize; ++i) {
        this._symbolData[i].yPos += travelDistance;
      }

      // check if the bottom preapperture symbol is now fully in view
      let symbolHeight = this.getSymbolHeight(
        this._bottomPreAppertureSymbolIdx
      );
      let bottomOfWindowPos = this._maxAppertureHeight * this._minSymbolSpacing; // the Y pos for the bottom of the reel window
      let topOfSymbolPos =
        this._symbolData[this._bottomPreAppertureSymbolIdx].yPos;
      let bottomOfSymbolPos = topOfSymbolPos + symbolHeight;
      let topInView =
        this._symbolData[this._bottomPreAppertureSymbolIdx].yPos >= 0;
      let bottomInView = bottomOfSymbolPos <= bottomOfWindowPos;
      let fullyInView = this._reelParameters.reverse ? bottomInView : topInView;
      let fullyOutOfView =
        topOfSymbolPos > bottomOfWindowPos || bottomOfSymbolPos < 0; // can happen with very slow frame rate
      if (fullyInView || fullyOutOfView) {
        // by checking both top and bottom then reverse spin works too
        let overShot = this._symbolData[this._bottomPreAppertureSymbolIdx].yPos;
        if (this._reelParameters.reverse) {
          overShot =
            (this._symbolData[this._bottomPreAppertureSymbolIdx].yPos +
              symbolHeight -
              bottomOfWindowPos) *
            -1;
        }
        this.copySymbolIdsToNextSymbol(); // must be called before resetSymbolPositions as this may change appertureHeight of symbols
        this.resetSymbolPositions();
        // MIKE, do we want to announce the top most preapp or bottom? Technically the top is the new symbol, but from players view it is the bottom pre app symbol...
        if (this._onNewSymbolCallback)
          this._onNewSymbolCallback(
            this._reelId,
            this._symbolData[this._preAppertureSymbolIdx],
            this._preAppertureSymbolIdx
          ); // new symbols are always added to the preapperture

        // dont calculate over shot if we have landed
        if (
          this._currentInjector !== this._postInjector ||
          !this._postInjector.canLand()
        ) {
          while (overShot > 0) {
            let delta = Math.min(overShot, symbolHeight); // calculate a symbol at a time
            overShot -= delta;
            if (this._reelParameters.reverse) delta *= -1;
            this.updatePos(delta); // if we over shot we need to move the symbols again so it doesnt jitter when resetting back to 0
            if (
              this._currentInjector === this._postInjector &&
              this._postInjector.canLand()
            )
              break;
          }
        }
      }
    }

    // how far to move symbols in pixels. Takes into account reverse direction
    calculateTravelDistance(delta) {
      let travelDistance =
        this._minSymbolSpacing *
        (delta / 1000) *
        this._reelParameters.symbolsPerSecond;
      if (this._reelParameters.reverse) {
        // reverse travel distance if reverse spin
        travelDistance *= -1;
      }

      this._travelledSinceStart += travelDistance;
      return travelDistance;
    }

    // MIKE should include reverse
    getSymbolsStillInWindow(includeTopMostPreApp) {
      let symbolsStillInWindow = [];
      // symbolsStillInWindow are bottom up
      // add post app

      for (let i = 0; i < this._postAppertureSymbols; ++i) {
        let idx = this._symbolData.length - 1 - i;
        symbolsStillInWindow.push(this._symbolData[idx].symId);
      }
      // add window
      for (let i = this._maxAppertureHeight - 1; i >= 0; --i) {
        symbolsStillInWindow.push(this._symbolData[i].symId);
      }

      // add pre app
      let numberOfPreapp = includeTopMostPreApp
        ? this._preAppertureSymbols
        : this._preAppertureSymbols - 1;
      for (let i = 0; i < numberOfPreapp; ++i) {
        let idx = this._bottomPreAppertureSymbolIdx - i;
        symbolsStillInWindow.push(this._symbolData[idx].symId);
      }

      return symbolsStillInWindow;
    }

    // function that moves the symbol ids to the next symbol space. This is because the animation only travels one symbol before resetting
    // the y positions back to the top so it needs to appear like the symbol is continuing to spin
    copySymbolIdsToNextSymbol() {
      let self = this;

      if (!this._reelParameters.reverse) {
        // MIKE need to decide if this for the last post app or first post app once it is out of view?
        if (this._onOldSymbolRemovedCallback) {
          this._onOldSymbolRemovedCallback(
            this._reelId,
            this._symbolData[this._maxAppertureHeight - 1],
            this._maxAppertureHeight - 1
          );
        }

        function copyIndices(fromId, toId, numToCopy) {
          // all symbols in view minus the top most symbol in view (idx 0)
          for (let i = 0; i < numToCopy; ++i) {
            // copy from neighbouring symbols, but not first or preapp/postapp as these need handling seperate below. Just the window symbols here minus first
            self._symbolData[fromId - i].symId =
              self._symbolData[toId - i].symId;
            self._symbolData[fromId - i].uniqueId =
              self._symbolData[toId - i].uniqueId;
            self._symbolData[fromId - i].appertureHeight =
              self._symbolData[toId - i].appertureHeight;
          }
        }

        // copy post apperture symbols
        copyIndices(
          this._symbolData.length - 1,
          this._symbolData.length - 2,
          this._postAppertureSymbols - 1
        );

        // the first post apperture symbol becomes the previous lowest symbol in window
        copyIndices(
          this._postAppertureSymbolIdx,
          this._maxAppertureHeight - 1,
          1
        );
        copyIndices(
          this._maxAppertureHeight - 1,
          this._maxAppertureHeight - 2,
          this._maxAppertureHeight - 1
        );
        copyIndices(0, this._bottomPreAppertureSymbolIdx, 1);
        copyIndices(
          this._bottomPreAppertureSymbolIdx,
          this._bottomPreAppertureSymbolIdx - 1,
          this._preAppertureSymbols - 1
        );

        let symbolsStillInWindow = this.getSymbolsStillInWindow(false); // needed for distance rules etc. Dont include top most as we are about to give it a new symbol

        // add a new symbol to the top most preapperture symbol
        this._symbolData[this._preAppertureSymbolIdx].symId =
          this._currentInjector.getValidSymbol(
            symbolsStillInWindow,
            this._reelId
          ); // get a new symbol from injector

        if (this._reelId === 'reel0') {
          console.log(
            '*** Injector: ' +
              this._symbolData[this._preAppertureSymbolIdx].symId
          );
        }

        this._symbolData[this._preAppertureSymbolIdx].uniqueId = this
          ._runningUniqueId++;
        this._symbolData[this._preAppertureSymbolIdx].appertureHeight =
          this._currentAppertureHeight;
      } else {
        function copyIndices(fromId, toId, numToCopy) {
          // all symbols in view minus the top most symbol in view (idx 0)
          for (let i = 0; i < numToCopy; ++i) {
            // copy from neighbouring symbols, but not first or preapp/postapp as these need handling seperate below. Just the window symbols here minus first
            self._symbolData[fromId + i].symId =
              self._symbolData[toId + i].symId;
            self._symbolData[fromId + i].uniqueId =
              self._symbolData[toId + i].uniqueId;
            self._symbolData[fromId + i].appertureHeight =
              self._symbolData[toId + i].appertureHeight;
          }
        }

        // copy post apperture
        copyIndices(
          this._postAppertureSymbolIdx + this._postAppertureSymbols - 2,
          this._postAppertureSymbolIdx + this._postAppertureSymbols - 1,
          this._postAppertureSymbols - 1
        );

        // copy symbol moving out of window to post
        copyIndices(0, this._postAppertureSymbolIdx, 1);

        // copy window symbols
        copyIndices(0, 1, this._maxAppertureHeight - 1);

        // copy pre to bottom of the window
        copyIndices(
          this._maxAppertureHeight - 1,
          this._preAppertureSymbolIdx + this._preAppertureSymbols - 1,
          1
        );

        // copy all pre
        copyIndices(
          this._preAppertureSymbolIdx + this._preAppertureSymbols - 1,
          this._preAppertureSymbolIdx + this._preAppertureSymbols - 2,
          this._preAppertureSymbols - 1
        );

        let symbolsStillInWindow = this.getSymbolsStillInWindow(false);
        this._symbolData[this._preAppertureSymbolIdx].symId =
          this._currentInjector.getValidSymbol(symbolsStillInWindow); // get a new symbol from injector
        this._symbolData[this._preAppertureSymbolIdx].uniqueId = this
          ._runningUniqueId++;
        this._symbolData[this._preAppertureSymbolIdx].appertureHeight =
          this._currentAppertureHeight;
      }
    }

    initialiseInjectors() {
      this._preInjector.transferTargetSymbolsToPreceedingSymbols(
        this._postInjector
      );

      let symbolsStillInWindow = this.getSymbolsStillInWindow(true);
      this._preInjector.initialise(symbolsStillInWindow);
      this._postInjector.initialise(symbolsStillInWindow);
    }

    saveInjectorsState() {
      this._preInjector.saveState();
      this._postInjector.saveState();
    }

    saveSymbolData() {
      this._savedSymbolData = JSON.parse(JSON.stringify(this._symbolData));
    }

    startSpin(callbackNewSymbol, callbackOldSymbol) {
      this._runningDelta = 0;
      this._travelledSinceStart = 0;
      this.initialiseInjectors();
      this.saveInjectorsState();
      this.saveSymbolData();
      this._reelSpinning = true;
      this._slamStopReels = false;
      this._currentInjector = this._preInjector;
      this._onNewSymbolCallback = callbackNewSymbol;
      this._onOldSymbolRemovedCallback = callbackOldSymbol;
      this.stateMachine.switchState('PULLBACK');
    }

    setAbortSymbols(abortSymbols) {
      this._abortSymbols = abortSymbols;
    }

    abortSpin() {
      this._aborted = true;
      this._bouncing = false;
      this._preInjector.reset();
      this._postInjector.reset();

      let abortCopy = JSON.parse(JSON.stringify(this._abortSymbols));

      for (let i = 0; i < abortCopy.length; ++i) {
        this.setReelSymbol(i, abortCopy[i]);
      }

      this._preInjector.initialise(abortCopy);
      this._postInjector.initialise(abortCopy);
      this.resetSymbolPositions();
      this.stateMachine.switchState('IDLE');
    }

    landReel(callback, hitCallback) {
      this.stateMachine.switchState('SPIN_TO_TARGET');
      this._spinTime = 0;
      this._onLandCallback = callback;
      this._onHitCallback = hitCallback;
      this._currentInjector = this._postInjector;
    }

    nudgeReel(newWindow, callback) {
      this._reelSpinning = true;
      this.stateMachine.switchState('NUDGE');
      this._onLandCallback = callback;

      this._symbolsAfterNudge = newWindow;

      let idOfLastSymbol = this._symbolData[this._symbolData.length - 2].symId;
      let yPosOfLastSymbol = this._symbolData[this._symbolData.length - 2].yPos;

      for (let i = 0; i < this._symbolsAfterNudge.length; ++i) {
        this.setReelSymbol(i, this._symbolsAfterNudge[i]);
      }

      for (let i = 0; i < this._symbolData.length; ++i) {
        this._symbolData[i].yPos -= 96;
      }

      this._symbolData[this._symbolData.length - 1].symId = idOfLastSymbol;
      this._symbolData[this._symbolData.length - 1].yPos = yPosOfLastSymbol;
    }

    slamStop() {
      this._slamStopReels = true;
    }

    jumpToTargetPosition() {
      console.log('Jumping to position for reel ' + this._reelId);
      if (this._currentInjector !== this._postInjector) {
        console.log(
          'Cannot slam stop reel ' + this._reelId + ' still in infinite spin'
        );
        return false;
      }

      this.stateMachine.switchState('IDLE');
      while (!this._postInjector.canLand()) {
        this.copySymbolIdsToNextSymbol();
        this.resetSymbolPositions();
      }

      if (this._onHitCallback) {
        this._onHitCallback(this._reelId);
        this._onHitCallback = undefined;
      }

      if (this._onLandCallback) {
        this._onLandCallback(this._reelId);
        this._onLandCallback = undefined;
      }

      return this._postInjector.canLand();
    }

    applyBounceOffset(
      reelSpinnerData,
      maxAppertureHeight,
      minSymbolSpacing,
      bounceDistance,
      progress,
      numPreapp,
      numPostapp
    ) {
      //window symbols
      for (let i = 0; i < maxAppertureHeight; ++i) {
        reelSpinnerData._symbolData[i].yPos =
          minSymbolSpacing * i + progress * minSymbolSpacing * bounceDistance;
      }

      let offset = maxAppertureHeight;
      // preapperture (above)
      for (let i = 0; i < numPreapp; ++i) {
        reelSpinnerData._symbolData[offset + i].yPos =
          minSymbolSpacing * (-numPostapp + i) +
          progress * minSymbolSpacing * bounceDistance;
      }

      offset = maxAppertureHeight + numPreapp;
      // post apperture
      for (let i = 0; i < numPostapp; ++i) {
        reelSpinnerData._symbolData[offset + i].yPos =
          minSymbolSpacing * (maxAppertureHeight + i) +
          progress * minSymbolSpacing * bounceDistance;
      }
    }

    state_idle() {
      if (this.phase.enter()) {
        this._aborted = false;
        this._isSpinning = false;
        this._bouncing = false;
      }
      if (this.phase.exit()) {
        this._isSpinning = true;
      }
    }

    state_pullback() {
      if (!this.phase.exit()) {
        this.stateMachine.switchState('ACCELERATE');
      }
    }

    state_accelerate() {
      if (!this.phase.exit()) {
        this.stateMachine.switchState('INFINITE_SPIN');
      }
    }

    state_infinite_spin() {
      if (!this._aborted) {
        // not great, needed to add it in for the transtion to idle after positions were reset in abortSpin because it then gets moved during this states transitions.
        this.updatePos(this.calculateTravelDistance(this._deltaTime));
      }
    }

    state_spin_to_target() {
      if (this.phase.hold()) {
        if (this._slamStopReels) {
          this.jumpToTargetPosition();
          this._slamStopReels = false;
          return;
        }

        if (this._postInjector.canLand()) {
          this.phase.step();
        } else {
          this._spinTime += this._deltaTime;
          this.updatePos(this.calculateTravelDistance(this._deltaTime));
          if (this._postInjector.canLand()) {
            this.phase.step();
          }
        }
      }

      // I am moving bounce animation here rather than its own state as state transitions can cause duplicate y values across frames which looks like a judder
      if (this.phase.once()) {
        // check here to stop reel land events from happening out of order. Steve sees this a lot. If say reel 1 canLand and goes in to the bounce state but the frame after the player hits slam stop then
        // reels 1 to 5 will all jump and call land callbacks but reel 0 wont because it is currently exiting this state
        if (this._slamStopReels) {
          this.jumpToTargetPosition();
          this._slamStopReels = false;
        }
        this.resetSymbolPositions();
        console.log(
          'Reel ' +
            this._reelId +
            ' took to land ' +
            this._spinTime +
            'total spin time ' +
            this._runningDelta +
            ' symbols injected ' +
            this._postInjector.getNumSymbolsInjected()
        );

        // are we going to bounce?
        this._bouncing = this._reelParameters.bounceDistance !== 0;
        if (!this._bouncing) {
          this.stateMachine.switchState('IDLE');
          if (this._onHitCallback) {
            this._onHitCallback(this._reelId);
            this._onHitCallback = undefined;
          }
          return;
        } else {
          let totalBounceTime = this._reelParameters.bounceTime * 1000;
          this._bounceDownTime = Math.max(
            (1000 / this._reelParameters.symbolsPerSecond) *
              this._reelParameters.bounceDistance
          );
          this._bounceUpTime = Math.max(
            0,
            totalBounceTime - this._bounceDownTime
          );
        }
      }

      // phases below are only active if it will be bouncing
      if (this.phase.timed(this._bounceDownTime)) {
        this.applyBounceOffset(
          this,
          this._maxAppertureHeight,
          this._minSymbolSpacing,
          this._reelParameters.bounceDistance,
          this.phase.Progress,
          this._preAppertureSymbols,
          this._postAppertureSymbols
        );
      }

      if (this.phase.once()) {
        if (this._onHitCallback) {
          this._onHitCallback(this._reelId);
          this._onHitCallback = undefined;
        }
      }

      if (this.phase.timed(this._bounceUpTime)) {
        this.applyBounceOffset(
          this,
          this._maxAppertureHeight,
          this._minSymbolSpacing,
          this._reelParameters.bounceDistance,
          1 - this.phase.Progress,
          this._preAppertureSymbols,
          this._postAppertureSymbols
        );
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('IDLE');
      }

      if (this.phase.exit()) {
        this.resetSymbolPositions();
        if (this._onLandCallback) {
          this._onLandCallback(this._reelId);
          this._onLandCallback = undefined;
        }
        this._slamStopReels = false;
        this._reelSpinning = false;
        this._bouncing = false;
      }
    }

    state_decelerate() {}

    // needs rewriting, was implemented for a game that had the mechanic abandoned before complete
    state_nudge() {
      if (this.phase.timed(700)) {
        this.resetSymbolPositions();
        let yPosOfLastSymbol =
          this._symbolData[this._symbolData.length - 2].yPos + 96;
        let movement = Math.cos(this.phase.Progress * (Math.PI / 2.0)) * -96;
        for (let i = 0; i < this._symbolData.length; ++i) {
          this._symbolData[i].yPos += movement;
        }

        this._symbolData[this._symbolData.length - 1].yPos =
          yPosOfLastSymbol + movement;
      }

      if (this.phase.once()) {
        this.resetSymbolPositions();

        for (let i = 0; i < this._symbolsAfterNudge.length; ++i) {
          this.setReelSymbol(i, this._symbolsAfterNudge[i]);
        }

        this._reelSpinning = false;
        if (this._onLandCallback) {
          this._onLandCallback(this._reelId);
          this._onLandCallback = undefined;
        }
      }
    }
  }
  module.exports = function (
    reelId,
    maxAppertureHeight,
    symbolSpacing,
    reservedSpace,
    numPreapp,
    numPostapp
  ) {
    return new ReelSpinnerData(
      reelId,
      maxAppertureHeight,
      symbolSpacing,
      reservedSpace,
      numPreapp,
      numPostapp
    );
  };
})();
